import React from 'react';
import i18n from 'i18next';
import { connect } from 'react-redux'
import { Spin } from 'antd';
import { SkosRepository } from '../../redux';


/** Компонента, отображающая статистику использования концептов */
const Loaded = () => <span>&nbsp;<Spin size="small" /></span>

const Label = ({count}) => {
    return (
        <span>{i18n.t('skos.scheme.countUsed')}: {count}</span>
    )
}
class ConceptSchemeUsed extends React.Component {
    
    state = {
        loaded: true,
        count: 0,
        values: undefined
    };

    componentWillMount() {
        const { values } = this.state;
        if ((values==undefined)|| (values==null)) 
            this.makeLabel();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.uris != this.props.uris)
            this.makeLabel(prevProps);
    }

    componentWillReceiveProps(nextProps){
        const { values } = this.state;
        if ((values==undefined)|| (values==null)) 
            this.makeLabel();
    }

    makeLabel () {
        const {vset, graph, uris} = this.props;        
        this.props.dispatch(SkosRepository.    countThemeUsed(uris))
            .then ((response) =>{
                //console.log("Done!", response);
                const {results} = response;
                const {bindings} = results;
                const count = Array.isArray(bindings) && bindings.length>0 ? bindings[0]['themeUsageCount'].value: 0;
                this.setState({loaded: false, values: bindings, count});
            })
            .catch(e => { 
                console.log("Error!", e);
            });
}

    render(){
        console.log(this);
        const Component = (this.state.loaded)? Loaded: Label;
        return(
            <Component {...this.props} {...this.state} />
        )
    }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vowl, vset} = state;
    //Параметры, которые могут прийти из настроек
    const {graph, iri, lang } = props;
    const rGraph = (graph)? graph: vset.graph;
    return {
        graph: rGraph,
        lang: (lang)?lang: vset.lang,
        ...props,
        vset
    };
}

export default connect(mapStateToProps)(ConceptSchemeUsed);